<template>
    <div class="notes">
        <div class="info">
            <h3 class="bullet01">Шинжилгээ өгөхийн өмнөх өдөр</h3>
            <p class="bullet03 depth">Согтууруулах ундаа хэтрүүлэн хэрэглэх, хэт ачаалалтай ажиллахаас татгалзах хэрэгтэй. Тайван тогтуун байж, хангалттай унтаж амраарай.</p>
            <p class="bullet03 depth">Эрүүл мэндийн.асуулгын хуудсаа урьдчилан хариулж бөглөөд шинжилгээ өгөх өдөр заавал авчирна уу.</p>

            <h4 class="bullet02 depth">Хоол хорих</h4>
            <p class="bullet03 depth">Оройн 7 цагаас өмнө хөнгөн хооллоорой.</p>
            <p class="bullet03 depth">Оройн 9 цагаас хойш хоол бүү идээрэй.(ус уух, бохь зажилах, тамхи татах ч бас үүнд хамаарна)</p>

            <h4 class="bullet02 depth">Өтгөний сорьц авах</h4>
            <p class="bullet03 depth">Өтгөний сорьцыг аль болох шинжилгээ өгөхийн өмнөх өдөр авна уу.</p>
            <p class="bullet03 depth">Бүдүүн гэдэсний дурангийн шинжилгээ өгөхөөр захиалга өгсөн үйлчлүүлэгчид хоолны дэглэм болон туулгах эм уух аргыг тусгайлан зааж өгнө</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Шинжилгээ өгөх өдөр</h3>
            <p class="bullet03 depth">Өглөөний хоол идэхгүй байхаас гадна ус ууж, тамхи татаж, бохь зажилж болохгүй.</p>
            <p class="bullet03 depth">Төвд ирэхдээ эрүүл мэндийн асуулгын хуудас, өтгөний сорьцтой сав, нүдний шил, контакт линз зэргээ авч ирнэ үү.</p>
            <p class="bullet03 depth">Эрүүл мэндийн шинжилгээний багцанд шээсний шинжилгээ бас багтсан байдаг тул бүртгүүлсний дараа шээсээ аваарай.</p>

            <h4 class="bullet02 depth">Эм бэлдмэл</h4>
            <p class="bullet03 depth">Даралтны эм, таталтын эсрэг эм: Шинжилгээ хийлгэх өдрийн өглөө(6 цагийн орчим) нэг балга усаар даруулж ууна.</p>
            <p class="bullet03 depth">Чихрийн шижингийн эм(инсулин тариа бас хамаарна): Хоол хорьсон цагаас цагаас эхлээд инсулин тариа болон чихрийн шижингийн эм уухаа зогсоох хэрэгтэй.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Бусад</h3>
            <p class="bullet03 depth">Үнэ цэнэтэй зүйлээ биедээ авч явахгүй байхыг хичээгээрэй.</p>
            <p class="bullet03 depth">Жирэмсэлсэн байж болзошгүй хүмүүс шинжилгээ өгөхөөсөө өмнө жирэмсэн болсон эсэхээ шалгаарай.</p>
            <p class="bullet03 depth">Эмэгтэй үйлчлүүлэгчид сарын тэмдэг ирээгүй өдрөө сонгон шинжилгээ өгөх нь тохиромжтой. Сав авахуулах мэс засал хийлгэсэн үйлчлүүлэгч ч гэсэн аарцагны дотор байрлах эрхтнүүд хэвийн эсэхийг эмэгтэйчүүдийн эмчид
                үзүүлэх шинжилгээ багтсан байдаг.</p>
            <p class="bullet03 depth">Бүлэгнэлтийн эсрэг эм бэлдмэл(аспирин зэрэг) ууж байгаа хүн ходоодны дурангаар эдийн шинжилгээ хийлгэх юм уу ур авах мэс ажилбар хийлгэх тохиолдолд цус алдах магадлалтай тул шинжилгээ хийлгэхээс нэг долоо
                хоногийн өмнө тухайн эмийг бичиж өгсөн эмчлэгч эмчтэйгээ урьдчилан зөвлөх шаардлагатай бөгөөд эмээ үргэлжлүүлэн уусаар байх уу эсвэл уухаа зогсоох уу гэдгээ шийдвэрлэж зааврыг дагана. Шинжилгээ хийлгэхээр ирсэн өдрөө эм ууж байгаа
                эсэх талаар мэдэгдэнэ үү.</p>
            <p class="bullet03 depth">Ходоодны дурангийн шинжилгээнд унтуулгатай орох гэж байгаа үйлчлүүлэгч асран хамгаалагчтайгаа ирэх бөгөөд тухайн өдрөө машин жолоодож болохгүй.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Анхаарах эм бэлдмэл</h3>
            <p class="bullet03 depth">Чихрийн шижингийн эмнүүдээс метформины найрлагатай эм бэлдмэл(жишээлбэл: Diabex, Janumet, Glupa, Trajenta Duo, Amaryl M) уудаг бол тодосгогч хэрэглэдэг шинжилгээ өгсний дараа 48 цагийн тус эм бэлдмэлийг уухыг
                зогсоох хэрэгтэй.</p>
            <p class="bullet03 depth">Цус бүлэгнэлтийн эсрэг үйлчлэлтэй эм бэлдмэл ууж байгаа хүн ходоодны дурангаар эдийн шинжилгээ хийлгэх юм уу ур авах мэс ажилбар хийлгэх тохиолдолд цус алдах магадлалтай тул шинжилгээ хийлгэхээс нэг долоо
                хоногийн өмнө тухайн эмийг бичиж өгсөн
                эмчлэгч эмчтэйгээ урьдчилан зөвлөх шаардлагатай бөгөөд эмээ үргэлжлүүлэн уусаар байх уу эсвэл уухаа зогсоох уу гэдгээ шийдвэрлэж зааврыг дагана. Шинжилгээ хийлгэхээр ирсэн өдрөө эм ууж байгаа эсэх талаар мэдэгдэнэ үү.</p>

            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_01.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_02.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_03.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_04.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_05.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
            </ul>
        </div>

        <div class="info">
            <h4 class="bullet02">Антитромботик цус бүлэгнэлтийн эсрэг эм бэлдмэлийн жишээ</h4>
            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_06.jpg" alt=""></div>
                    <div class="tit">Aspirin Protect Tab</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_07.jpg" alt=""></div>
                    <div class="tit">Astrix</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_08.jpg" alt=""></div>
                    <div class="tit">Plavix</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_09.jpg" alt=""></div>
                    <div class="tit">Pletaal Tab</div>
                </li>
            </ul>
        </div>

        <div class="info">
            <h4 class="bullet02">Антикоагулянт цус бүлэгнэлтийн эсрэг эм бэлдмэлийн жишээ</h4>
            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_10.jpg" alt=""></div>
                    <div class="tit">Warfarin</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_11.jpg" alt=""></div>
                    <div class="tit">Paradaxa</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_12.jpg" alt=""></div>
                    <div class="tit">Xarelto</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_13.jpg" alt=""></div>
                    <div class="tit">Eliquis</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_14.jpg" alt=""></div>
                    <div class="tit">Lixiana</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>